<script>
	let showLegal = false;

	let scrollY;

	let keywords = {
			"tangible": "It makes a difference, to hold your idea in your hands. Once you can touch and interact with an object, it's easier to see its full potential and show it to others. Our work brings together all the steps and components needed to give you this experience. Understanding your idea, identifying suitable technologies and implementing them in soft- and hardware, until your idea stands as a functional model on your table - that is our expertise.",

			"research": "tForge provides research as a service. Meaning: to follow up on your ideas, you don't need to hire additional employees with specialty skills nor invest into research facilities. Foremost in the early stage of an idea, this often makes no sense economically and significantly delays progress.",

			"engineering": "Customers expect to see in your products the functionality, usability, connectivity and cost advantage that modern technologies offer. Be it an entirely new device or an update of a successful product in your portfolio - we offer user-centric product development that adds value to your devices.",

			"prototypes": "We build mock-ups, functional models and prototypes in our workshop to let you see and touch the progress made in the agile development process. Such tangible intermediate results are crucial to align with stakeholders like product users or project sponsors. Their feedback can thus be incorporated early on, reducing the overall risk and cost.",

			"optics" : "Many of our projects are related to optical measurements. Years of experience in academic and industrial research related to this topic help us to find optimal solutions within your constrains. Key is our understanding and optimization of the overall system - from the light sources, optics elements, sensors and cameras, image and signal processing to a meaningful data representation.",
			
			"electronics": "Especially compact devices benefit significantly from our capabilities to design and assemble project specific PCBs. Since mechanical design (mCAD) and PCB design (eCAD) are both made in house, they are optimized together for smaller footprint, robustness and cost reduction. It also enables us to integrate sensors, actuators and peripheries like SOC with an optimal layout.",

			"software": "From setting single bits to control a micro sensor to writing user interfaces with database backends - our work includes a wide range of software topics. Our software is designed and documented to be maintained and extended easily by anyone familiar with the respective programming language. We focus on flexibility to explore a maximum of ideas and possibilities during development. Once the final version is decided, it can be optimized for speed and other aspects.",

			"machine learning & AI": "Many years of experience in machine learning and AI have taught us to keep an eye on the full data flow, from optimal measuring conditions and sensible feature selection for optimal training conditions, over selecting a suitable machine learning technique up to a sober interpreation of the AI output.",

			"intellectual property": "You own the IP we developed for you. This refers not only to patents based on our work (currently three patents based on our work are pending). Even more importantly: The entire work is frictionlessly handed over to you; you receive all the research data, prototypes, drawings, PCB layouts, bill of material, documented source code, … . The full controll over your IP gives you freedom to operate and let you expand on your idea in the future.",

			"agile": "We have experience in managing large international projects (as shown by a PMP certification). Yet we have seen how R&D benefits from breaking down big projects in smaller, iterative steps with tangible deliveries. We thus aim for 2 to 6 months long projects with well defined objectives, which have proven to significantly accelerate development. Our lean approach reduces planning risk and administrative overhead and thus saves you time and money. \nAgile also means to know when to stop: If you decide during the project not to pursue the idea further, we simply stop the project and you only pay for the hours actually worked and material used."

	}
	let selectedKeyword = 'tangible';

	
</script>
	
<svelte:window bind:scrollY={scrollY} />

<!-- --- === ===  HTML  === === --- -->

<main>
	<div id="topBar" class:top-compact={scrollY > 200}
		on:click={() => showLegal=false}>
		<img id="topLogo"src="img/tForge_Logo_text_blue.png" alt="">
		<div class="nav-btn" on:click={() => {showLegal=true; document.getElementById("contact").scrollIntoView(true);}}>Contact</div>
		<div class="nav-btn" on:click={() => {window.open("https://share.tforge.eu", '_blank').focus();}}>Customer login</div>
	</div>

	{#if showLegal}

	<div id="legal" class="section">
		<h1 >Impressum</h1>
	
		<h3>Angaben gemäß § 5 TMG:</h3>
		<div class="txt-block">
			<p>tForge Ingenieurbüro GmbH</p>
			<p>Steinstr. 29</p>
			<p>61476 Kronberg im Taunus</p>
			<p></p>
			<p>Eingetragen im Handelsregister Königstein unter HRB 10801</p>		
		</div>
	
		<h3>Geschäftsführer:</h3>
		<div class="txt-block">
			<p>Dr. Robert Fischer</p>
			<p>Eric Schunda</p>
		</div>
	
		<h3>EORI:</h3>
		<div class="txt-block">
			<p>EORI-Nummer: DE373358162028781</p>
		</div>
	
		<h3>Umsatzsteuer-ID:</h3>
		<div class="txt-block">
			<p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: </p>
			<p>DE343223136</p>
		</div>
	
		<h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
		<div class="txt-block">
			<p>Dr. Robert Fischer</p>
			<p>Steinstr. 29</p>
			<p>61476 Kronberg im Taunus</p>
		</div>
	
		<h3>Hinweis auf EU-Streitschlichtung</h3>
		<p>
		  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br/>
		  <a href="https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show&lng=DE" target="_blank">http://ec.europa.eu/consumers/odr</a>
		</p>

		<div style="height: 6em;"></div>

		<h1 id="datenschutz">Datenschutzerklärung</h1>

        <h3>Datenschutz und Cookies</h3>
        <p>Diese Seite sammelt keine personenbezogenen Daten. Es werden keine Cookies verwendet. Nutzerdaten werden nicht mit Google Analytics, etracker oder ähnlichen Diensten gesammelt. Soweit es sich unter unserer Kontrolle befindet, ist diese Seite frei von Scripten oder Programmen die Daten an Dritte weiterleiten, wie dies z.B. bei der Einbindung von Social Media Diensten der Fall sein kann.
        </p>

        <h3>Server-Log-Files</h3>
        <p>
          Wenn Sie unsere Seite besuchen, hinterläßt Ihr Browser automatisch Informationen, welche der Server in einer sogenannten Log-Datei abspeichert. Diese Informationen umfassen neben dem genauen Zeitpunkt Ihrer Anfrage die von Ihnen verwendete IP, den Browsertyp, das Betriebssystem und mitunter sogar eine Angabe zu der Seite von der aus sie zu unserer Seite gelangt sind (Referrer URL). Diese Daten sind nicht bestimmten Personen zuordbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung oder technische Probleme mit dem Server bekannt werden.
        </p>
        <h3>Auskunft</h3>
        <p>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Bitte wenden Sie sich bei Fragen zum Thema personenbezogene Daten an die unten genannte Kontaktadresse, oder senden Sie eine E-Mail an unseren Datenschutzbeauftragten (datenschutz@tForge.eu).
        </p>


  	</div>

	
	{:else}

	<div id="converyor">
		<img src="/img/collage_tForge_w1200.jpg" alt="">
	</div>


	<div id="info" class="section">
		<h1>Research & Engineering</h1>
		<p>
		  Do you remember your ideas only once your competitor has turned them into a successful product? Then you
		  probably have more good ideas than you can follow-up on. Before a lack of time, personnel or other issues makes you
		  miss product opportunities, consider our services:
		</p>
		<p>
		  tForge helps you in the early stage of exploring your idea, from drafting a first concept up to the point where
		  you have a functional <strong>prototype</strong> in your hands.
		</p>
		<p>
		  We first work with you to understand your idea in the context of your business as well as from the user
		  perspective. We then identify, implement, test and refine suitable technologies. In our workshop, we manufacture
		  and assemble <strong>hardware</strong> (mechanics, electronics, optics, casing, etc.) which we `bring to life` with
		  a tailored <strong>software</strong> solution (machine learning, image processing, embedded systems,
		  web-interfaces, etc.).
		</p>
		<p>
		  Our agile <strong>project management</strong> is designed to let you steer the development with a minimum of
		  effort and risk: Smaller steps with tangible results allow you to update priorities and focus on the most
		  promising options. If you see reason to stop the project, you can do this typically with one or two weeks
		  notice.
		</p>
	</div>

	<div class="stripe">
		<div class="section">
			<h1>Services and Technologies</h1>

			<div id="keyWords">
				<div id="keyword-list">
					{#each Object.entries(keywords) as [key, description] (key)}
					<div class="keyword" class:activeKeyword={selectedKeyword==key}
					on:click={() => {selectedKeyword=key;}}>{key}</div>
					{/each}
				</div>
	
				<div id="keyWordCard">
					<h3>{selectedKeyword}</h3>
					<p>{keywords[selectedKeyword]}</p>
				</div>
			</div>
		</div>
	</div>
	

	<div id="customers" class="section">
		<h1>Some of our customers</h1>
		<div id="customerLogos">
			<img src="/img/Logo_customer1.svg" style="height: 2.3em;" alt="">
			<img src="/img/Logo_customer4.jpg" style="height: 4.8em;" alt="">
			<img src="/img/Logo_customer2.svg" alt="">
			<img src="/img/Logo_customer3.png" alt="">
		</div>
	</div>

	{/if}

	<div class="stripe">
		<div id="contact" class="section">
			<h1>Contact</h1>
			<p>
				Are you wondering, if we could help develop your idea? Then don't hesitate, 
				find out by <a href="mailto:sales@tforge.eu">sending us an email.</a>
			</p>
	  
			<p>
			  Our office address:
			</p>		 
			<div class="txt-block">
				<p>tForge Ingenieurbüro GmbH</p>
				<p>Steinstr. 29</p>
				<p>61476 Kronberg im Taunus</p>
				<p>Germany</p>
			</div>
	
			<p>
			  We are looking forward to hear from you!
			</p>
		</div>
	</div>


	
	<footer >
		<img id="footerLogo"src="img/tForge_Logo_sign_white.png" alt="" on:click={() => {showLegal=false; document.documentElement.scrollTop = 0; document.body.scrollTop = 0;}}>		
		<div class="footer-btn" on:click={() => {showLegal=true; document.documentElement.scrollTop = 0; document.body.scrollTop = 0;}}>Imprint (Impressum)</div>
		<div class="footer-btn" on:click={() => {showLegal=true; document.documentElement.scrollTop = 500; document.body.scrollTop = 500;}}>Privacy (Datenschutz)</div>
	</footer>
</main>



<!-- --- === === STYLE === === --- -->



<style>
	#topBar {
		position: fixed;
		width: 100%;
		top: 0px;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		background-color:rgba(255, 255, 255, 0.75);
		z-index: 10;
	}

	#topLogo {
		transition: 300ms ease-in-out;
		height: 5.5em;
		padding: 1em;
		margin-right: auto;
	}

	.nav-btn {
		font-size: 1.2em;
		font-weight: 400;
		color: var(--tF-blue);
		padding-left: 2em;
		padding-right: 2em;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.nav-btn:hover{
		background-color: var(--tF-blue);
		color: white;
		transition: 400ms ease-in-out;
	}

	.top-compact{
		transition: 300ms ease-in-out;
		background-color: rgba(255, 255, 255, 1);
		border-bottom: 2px solid var(--tF-blue);
	}
	.top-compact #topLogo{
		transition: 300ms ease-in-out;
		height: 4em;
	}
	.top-compact .nav-btn{
		background-color: white;
	}
	.top-compact .nav-btn:hover{
		background-color: var(--tF-blue);
		color: white;
		transition: 400ms ease-in-out;
	}

	#legal {
		margin-top: 3em;
	}
	#converyor{
		margin-top: -6em;
		top: 0px;
		width: 100%;
	}
	#converyor img{
		width: 100%;
		object-fit: contain;
		overflow: hidden;
		padding: 0px;

	}

	.stripe {
		color: black;
		padding-top: 2em;
		padding-bottom: 2em;
		width: 100%;
		background-color: var(--tF-lightGray);
	}

	p {
		margin-bottom: 0.75em;
	}

	.section {
		margin: auto;
		max-width: 1000px;
		padding: 4em;
	}

	#keyWords{
		display: flex;
		flex-direction: row;
	}
	#keyword-list{
		min-width: 15em;
	}
	.keyword{
		font-size: 1.2em;
		font-weight: 400;
		color: var(--tF-blue);
		padding: 0.5em 0em 0.5em 0.5em;
	}
	.keyword:hover{
		background-color: var(--tF-white);
	}
	.keyword:not(:last-child){
		border-bottom: 1px solid var(--tF-blue);
	}
	.activeKeyword{
		color: white;
		background-color: var(--tF-blue);
	}
	.activeKeyword:hover{
		color: white;
		background-color: var(--tF-blue);
	}
	#keyWordCard{
		padding-left: 4em;
		flex-grow: 1;
	}
	#keyWordCard h3{
		color: var(--tF-blue);
		font-size: 1.5em;
	}
	
	#customerLogos{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
		margin-top: 3em;
	}
	#customerLogos img{
		height: 2.7em;
	}


	.txt-block{
		margin: 0px 0px 1em 2em;
	}
	.txt-block p{
		margin: 0px;
	}


	footer {
		border-top: 1px solid var(--tF-blue);
		background-color: var(--tF-gray);
		padding: 2em;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;	
	}

	footer img {
		height: 3em;
		margin-right: auto;
	}

	.footer-btn {
		font-size: 1.1em;
		padding-left: 2em;
		padding-right: 2em;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.footer-btn:hover {
		transition: 300ms ease-in-out;
		background-color: #ccc;
	}
</style>